import { get, post, put, del } from '../../../core/api/client';
import { API_ENDPOINTS } from '../../../core/api/endpoints';

export const getUsers = async (clientId, params = {}) => {
  const { limit = 50, offset = 0, status } = params;
  let endpoint = `${API_ENDPOINTS.USERS.GET_BY_CLIENT(clientId)}?limit=${limit}&offset=${offset}`;
  if (status) endpoint += `&status=${encodeURIComponent(status)}`;
  return get(endpoint);
};

export const getUserById = async (id) => {
  return get(API_ENDPOINTS.USERS.GET_BY_ID(id));
};

export const getUserByEmail = async (email) => {
  return get(API_ENDPOINTS.USERS.GET_BY_EMAIL(email));
};

export const createUser = async (userData) => {
  return post(API_ENDPOINTS.USERS.CREATE, userData);
};

export const inviteUser = async (inviteData) => {
  return post(API_ENDPOINTS.USERS.INVITE, inviteData);
};

export const updateUser = async (id, userData) => {
  return put(API_ENDPOINTS.USERS.UPDATE(id), userData);
};

export const deleteUser = async (id) => {
  return del(API_ENDPOINTS.USERS.DELETE(id));
};
